import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getNotificationSetting(ctx) {
    try {
      const response = await api.getNotificationSetting();
      ctx.commit("getNotificationSettingSuccess", {
        notificationSetting: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async updateNotificationSetting(ctx, params) {
    try {
      const response = await api.updateNotificationSetting(params);
      ctx.commit("updateNotificationSettingSuccess", {
        notificationSetting: response.data
      });
    } catch (error) {
      throw error;
    }
  }
};

export default actions;
